import React from 'react';
import icon from 'components/Success/blue-small-right.png';
export const Success = ({ message }) => (React.createElement("div", { className: "success-msg-all" },
    React.createElement("img", { src: icon, alt: "Success" }),
    React.createElement("p", null, message)));
